<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  @if (data) {
    <modal-header-default
      class="border"
			[options]="{
				headerTitle: data.title || (data.titleKey ? (data.titleKey | translate) : '---')
			}"></modal-header-default>
    <div content class="end-screen-content">
      <img
        class="end-screen-img"
        src="/assets/images/deposit/success.svg"
        [alt]="data.header || (data.headerKey ? (data.headerKey | translate) : '---')" />
      <div class="end-screen-headline">{{
        data.header || (data.headerKey ? (data.headerKey | translate) : "---")
      }}</div>
      <p class="end-screen-description">{{
        data.description || (data.descriptionKey ? (data.descriptionKey | translate) : "---")
      }}</p>
      <!-- C+ should be removed in UK, comment for next sync -->
      <div class="end-screen-buttons-container">
        <button type="button" class="btn btn-primary" (click)="close()">{{
          data.doneButton || (data.doneButtonKey ? (data.doneButtonKey | translate) : "---")
        }}</button>
      </div>
    </div>
  }
</div>
